<template>
  <div class="custom-radio-button">
    <input
      :id="radioId"
      :name="name"
      :value="usedValue"
      :checked="isChecked(value, defaultChecked)"
      class="custom-radio-button-input"
      type="radio"
      @change="updateValue($event.target.value); $emit('change');">
    <label :for="radioId" class="custom-radio-button-label">
      <span>{{ label }}</span>
    </label>
  </div>
</template>

<script>
import UIComponentMixin from "../../Mixins/UIComponentMixin";

export default {
  name: "BoolRadioControl",

  mixins: [
    UIComponentMixin
  ],

  props: {
    name: { type: String },
    label: { type: String },
    value: { type: [Boolean, String, Number] },
    usedValue: { type: [Boolean, String, Number] },
    defaultChecked: { type: Boolean, default: false }
  },

  computed: {
    radioId () {
      return `${this.id}-${this.label}`;
    }
  },

  methods: {
    isChecked (value, defaultChecked) {
      if (this.value !== undefined && this.value !== null) {
        return this.value === this.usedValue;
      } else {
        return this.defaultChecked;
      }
    }
  }
};
</script>
